// extracted by mini-css-extract-plugin
export default {"highlight":"HalfHighlight_highlight__G1vEm","bg":"HalfHighlight_bg__InuZW","text":"HalfHighlight_text__04sLK"};